import { defineAction } from '~/prix'
import questionnairePropagateAnswersAction from './questionnairePropagateAnswers.action.json' with { type: 'json' }
import { z } from 'zod'

const questionnairePropagateAnswersDefinition = defineAction({
  ...questionnairePropagateAnswersAction,

  input: z.object({}),
  output: z.object({}),
})

export default questionnairePropagateAnswersDefinition
